export var MessageType;
(function (MessageType) {
    MessageType["INVALID_PATTERN"] = "INVALID_PATTERN";
    MessageType["VALUE_REQUIRED"] = "VALUE_REQUIRED";
    MessageType["VALUE_OUT_OF_RANGE"] = "VALUE_OUT_OF_RANGE";
})(MessageType || (MessageType = {}));
export * from './ambassador-types';
//# sourceMappingURL=index.js.map